import React from "react";
import styled from "styled-components";
import Heading from "../../../Heading";
import CaseStudiesCard from "../CaseStudiesCard";
import Rule from "../../../Rule";
import BlogLayout from "../BlogLayout";

const VideoWrapper = styled.div`
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  && {
    margin-top: var(--spacing-large);
  }
`;

const Video = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border none;
  border-radius: 24px;
  overflow: hidden;
`;

const Introduction = (
  <CaseStudiesCard id="typography">
    <Heading
      variant="smaller"
      style={{ marginTop: 0, marginBottom: "var(--spacing-x-tiny)", textTransform: "uppercase" }}
    >
      Video Workshop
    </Heading>
    <p style={{ marginBottom: 0, fontSize: "var(--font-size-text-medium)" }}>
      Creating a scalable typographic rhythm for the web.
    </p>
    <Rule spacing="medium" inverted mt="var(--spacing-medium)" mb="8rem" />

    <BlogLayout>
      <Heading variant="larger" maxWidth="30ch">
        Web Typography
      </Heading>

      <p>
        This workshop provides an introduction to the history of typography through letterpress and how we can use this
        foundation to inform our decisions when creating a typographic vertical rhythm with the use of a baseline grid.
      </p>

      <p>
        Embed these techniques within your foundational CSS file, which will be within your websites, web-apps or
        preferably a Design System.
      </p>

      <p>
        By setting these decisions with the foundational CSS file, it will ensure there is a well-balanced and rhythmic
        experience across the entire product range.
      </p>

      <VideoWrapper>
        <Video
          width="560"
          height="315"
          src="https://www.youtube.com/embed/FFGSy0EfA9Y"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        />
      </VideoWrapper>
    </BlogLayout>
  </CaseStudiesCard>
);

export default Introduction;
